import React from 'react';
import TirePressureKR from '@di-shared/features/diag/tire/TirePressureKR';
import TirePressureEu from '@di-shared/features/diag/tireEU/TirePressureEU';
import TirePressureNa from '@di-shared/features/diag/tireNA/TirePressure.na';
import Environment from '@di-shared/features/environment/Environment';
import environmentStore from '@di-shared/features/environment/environmentStore';

interface DiagTirePageProps {
  vin: string;
}

function DiagTirePage({vin}: DiagTirePageProps) {
  const puid = environmentStore.getState().puid;

  return (
    <>
      <Environment.Eu>
        <TirePressureEu
          vin={vin}
          puid={puid}
        />
      </Environment.Eu>
      <Environment.Kr>
        <TirePressureKR vin={vin} />;
      </Environment.Kr>
      <Environment.Na>
        <TirePressureNa vin={vin} puid={puid} />
      </Environment.Na>
    </>
  );
}

export default DiagTirePage;
